import React, { useState, useEffect } from 'react';
import { apiGet, apiPut } from '../../services/apiClient';
import TextInput from '../../controls/textInput.jsx';
import CountryPhoneInput from '../../controls/countryPhoneInput.jsx';

const ProfilePage = () => {
    const [user, setUser] = useState({});
    const [errors, setErrors] = useState({});
    const [isBusy, setIsBusy] = useState(false);

    useEffect(() => {
        setIsBusy(true);
        apiGet('profile')
            .then((data) => {
                setUser(data);
                setErrors({});
                setIsBusy(false);
            })
            .catch(() => {
                setIsBusy(false);
            });
    }, []);

    const handleInputChange = (name, value) => {
        setUser({
            ...user,
            [name]: value
        });
    };

    const save = () => {
        setErrors({});
        setIsBusy(true);
        apiPut('profile', user)
            .then(() => {
                setIsBusy(false);
            })
            .catch((err) => {
                setErrors(err.messages);
                setIsBusy(false);
            });
    };

    return (
        <div>
            <section className="content-header">
                <div className="row">
                    <div className="col-xs-12 col-lg-10 col-lg-offset-1">
                        <h1>Пользователь {user.login}</h1>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="row">
                    <div className="col-xs-12 col-lg-10 col-lg-offset-1">
                        <div className="box box-primary">
                            <div className="box-body">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className={"form-group" + (errors.userSurname ? " has-error" : "")}>
                                            <label htmlFor="inputSurname">Фамилия</label>
                                            <TextInput id="inputSurname"
                                                title={errors.userSurname}
                                                value={user.userSurname}
                                                onChange={value => handleInputChange("userSurname", value)}
                                                disabled={isBusy}
                                            />
                                        </div>
                                        <div className={"form-group" + (errors.userName ? " has-error" : "")}>
                                            <label htmlFor="inputName">Имя</label>
                                            <TextInput id="inputName"
                                                title={errors.userName}
                                                value={user.userName}
                                                onChange={value => handleInputChange("userName", value)}
                                                disabled={isBusy}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className={"form-group" + (errors.userPatronymic ? " has-error" : "")}>
                                            <label htmlFor="inputPatronymic">Отчество</label>
                                            <TextInput id="inputPatronymic"
                                                title={errors.userPatronymic}
                                                value={user.userPatronymic}
                                                onChange={value => handleInputChange("userPatronymic", value)}
                                                disabled={isBusy}
                                            />
                                        </div>

                                        <div className={"form-group" + (errors.contactInfo ? " has-error" : "")}>
                                            <label htmlFor="inputContactInfo">Телефон</label>
                                            <CountryPhoneInput id="inputContactInfo"
                                                title={errors.contactInfo}
                                                value={user.contactInfo}
                                                onChange={value => handleInputChange("contactInfo", value)}
                                                onEditComplete={() => { }}
                                                disabled={isBusy}
                                                defaultCountry="ru"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box-footer">
                                <button className="btn btn-flat btn-primary pull-right" onClick={save} disabled={isBusy}>
                                    Сохранить
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ProfilePage;


// WEBPACK FOOTER //
// ./App/pages/profile/profilePage.jsx